import Vue from 'vue';
import Router from 'vue-router';
import store from './store';
import Home from './views/Home.vue';
import Partner from './views/Partner.vue';
import ActivityDetail from './views/ActivityDetail.vue';
import NotFound from './views/404.vue';
import Logout from './views/Logout.vue';

const Redeem = () => import('./views/Redeem/Redeem.vue');
const RedeemVoucher = () => import('./views/Redeem/RedeemVoucher.vue');
const RedeemThanks = () => import('./views/Redeem/RedeemThanks.vue');
const RedeemNewsletter = () => import('./views/Redeem/RedeemNewsletter.vue');
const RedeemSignup = () => import('./views/Redeem/RedeemSignup.vue');
const PartnerThanks = () => import('./views/PartnerThanks.vue');

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/partners',
            name: 'partners',
            component: Partner,
        },
        {
            path: '/:campaign?/',
            name: 'home',
            component: Home,
        },
        {
            path: '/partners/thanks',
            name: 'partner.thanks',
            component: PartnerThanks,
        },
        {
            path: '/activiteiten/',
            name: 'activity_overview',
            component: Home,
        },
        {
            path: '/:campaign?/activiteiten/:activity_id',
            name: 'activity_detail',
            component: ActivityDetail,
        },
        {
            path: '/uitloggen',
            name: 'logout',
            component: Logout,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/:campaign?/activiteiten/:activity_id/verzilveren',
            component: Redeem,
            children: [
                {
                    path: '/',
                    name: 'redeem_voucher',
                    component: RedeemVoucher,
                    meta: {
                        requiresAuth: true,
                        backbtn: {
                            name: 'home',
                            icon: 'content_view',
                        },
                    },
                },
                {
                    path: 'aanmelden',
                    name: 'redeem_signup',
                    component: RedeemSignup,
                    meta: {
                        notAuth: true,
                        backbtn: {
                            name: 'activity_detail',
                            icon: 'arrow_left',
                        },
                    }
                },
                {
                    path: 'kidsclub',
                    name: 'redeem_newsletter',
                    component: RedeemNewsletter,
                    meta: {
                        requiresAuth: true,
                        backbtn: {
                            name: 'home',
                            icon: 'content_view',
                        },
                    },
                },
                {
                    path: 'bedankt',
                    name: 'redeem_thanks',
                    component: RedeemThanks,
                    meta: {
                        requiresAuth: true,
                        backbtn: {
                            name: 'home',
                            icon: 'content_view',
                        },
                    },
                }],
        },
        {
            path: '*',
            name: '404',
            component: NotFound
        },
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return new Promise((resolve) => {
                setTimeout(() => {
                    resolve(savedPosition)
                }, 1)
            });
        }

        return { x: 0, y: 0 };
    },
});

router.beforeEach((to, from, next) => {
    const api_token = JSON.parse(localStorage.getItem('api_token'));

    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!api_token) {
            if(to.params.activity_id) {
                return next({
                    name: 'redeem_signup',
                    params: to.params,
                    query: to.query
                });
            }
            return next({
                name: '404',
            })
        }

        store.dispatch('sportid/tokenRefresh', api_token).then(() => {
            next();
        });
    } else {
        next();
    }

    if (to.matched.some(record => record.meta.notAuth)) {
        if (api_token) {
            if(to.params.activity_id) {
                return next({
                    name: 'redeem_voucher',
                    params: to.params,
                    query: to.query
                });
            }
            else {
                next();
            }
        }
    }
});

router.beforeEach((to, from, next) => {
    router.app.$Progress.start();

    next();
});

router.afterEach(() => {
    router.app.$Progress.finish();
});

export default router;
